import { z } from 'zod';
import { PricingClassification, RateType, ReservationPurpose } from '@mews-commander/data-access';
import { MAX_INPUT_TEXT_LENGTH, MAX_READABLE_DECIMAL, Validation } from '@mews/framework';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { DetailsFieldName } from '../forms/types';

const INCREASED_MAX_DESCRIPTION_TEXT_LENGTH = 3500;

const nullOptStringSchema = z.string().nullable().optional().or(z.literal(''));

const nullOptNativeEnumSchema = <T extends z.EnumLike>(enumType: T) =>
    z.nativeEnum(enumType).nullable().optional().or(z.literal(''));

export const useRateDetailSchema = () => {
    const { defaultLanguageCode } = useCurrentEnterprise();

    return z.object({
        [DetailsFieldName.Names]: Validation.Localized.Required(defaultLanguageCode, { max: MAX_INPUT_TEXT_LENGTH }),
        [DetailsFieldName.ShortNames]: Validation.Localized.Optional({ max: MAX_INPUT_TEXT_LENGTH }),
        [DetailsFieldName.ExternalNames]: Validation.Localized.Optional({ max: MAX_INPUT_TEXT_LENGTH }),
        [DetailsFieldName.Descriptions]: Validation.Localized.Optional({ max: INCREASED_MAX_DESCRIPTION_TEXT_LENGTH }),
        [DetailsFieldName.IsEnabled]: z.boolean(),
        [DetailsFieldName.IsDefault]: z.boolean(),
        [DetailsFieldName.Ordering]: z.coerce.number().int().max(MAX_READABLE_DECIMAL).default(0),
        [DetailsFieldName.Type]: z.nativeEnum(RateType),
        [DetailsFieldName.ServiceId]: z.string(),
        [DetailsFieldName.RateGroupId]: z.string(),
        [DetailsFieldName.BaseRateId]: z.string().nullable().optional(),
        [DetailsFieldName.RateKey]: z.string().nullable().optional(),
        [DetailsFieldName.DefaultReservationPurpose]: nullOptNativeEnumSchema(ReservationPurpose),
        [DetailsFieldName.PricingClassification]: nullOptNativeEnumSchema(PricingClassification),
        [DetailsFieldName.AccountingCategoryId]: nullOptStringSchema,
        [DetailsFieldName.BusinessSegmentId]: nullOptStringSchema,
        [DetailsFieldName.IsBonusPointsEligible]: z.boolean().default(false),
        [DetailsFieldName.HidePriceFromGuest]: z.boolean().default(false),
    });
};
